<template>
    <div>
        <p class="label">Canaux</p>
        <MultiplePickerInput :value="value" @input="onInput" :items="items" v-bind="$attrs" />
    </div>
</template>

<script>
  import MultiplePickerInput from '@/components/inputs/MultiplePickerInput.vue';
  import StudentService from '@/services/student.service.js';

  export default {
    name: "ChannelMultiplePickerInput",
    components: {
      MultiplePickerInput,
    },
    props: {
      value: Array
    },
    data() {
      return {
        items: [],
      }
    },
    created() {
      const _this = this;

      StudentService.getChannel().then(({data}) => {
        _this.items = data;
      });
    },
    methods: {
      onInput(event) {
        this.$emit('input', event);
      }
    },
  }
</script>

<style scoped>

</style>
